export default __webpack_public_path__ + "ed43899b16b503dd2d9eea33edb8198e.svg";